const IconCompare = ({ width = 16, height = 18, fill = '#252525', style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M2.71927 5.44444C2.26329 5.44444 1.82599 5.25714 1.50356 4.92375C1.18114 4.59035 1 4.13816 1 3.66667C1 3.19517 1.18114 2.74299 1.50356 2.40959C1.82599 2.07619 2.26329 1.88889 2.71927 1.88889C3.17525 1.88889 3.61255 2.07619 3.93498 2.40959C4.25741 2.74299 4.43854 3.19517 4.43854 3.66667C4.43854 4.13816 4.25741 4.59035 3.93498 4.92375C3.61255 5.25714 3.17525 5.44444 2.71927 5.44444ZM2.71927 5.44444V12.5556C2.71927 13.0271 2.90041 13.4792 3.22283 13.8126C3.54526 14.146 3.98256 14.3333 4.43854 14.3333H8.73672M13.0349 12.5556C13.4909 12.5556 13.9282 12.7429 14.2506 13.0763C14.573 13.4097 14.7542 13.8618 14.7542 14.3333C14.7542 14.8048 14.573 15.257 14.2506 15.5904C13.9282 15.9238 13.4909 16.1111 13.0349 16.1111C12.5789 16.1111 12.1416 15.9238 11.8192 15.5904C11.4968 15.257 11.3156 14.8048 11.3156 14.3333C11.3156 13.8618 11.4968 13.4097 11.8192 13.0763C12.1416 12.7429 12.5789 12.5556 13.0349 12.5556ZM13.0349 12.5556V5.44444C13.0349 4.97295 12.8538 4.52076 12.5313 4.18737C12.2089 3.85397 11.7716 3.66667 11.3156 3.66667H7.01745M7.01745 3.66667L9.59636 6.33333M7.01745 3.66667L9.59636 1M8.73672 14.3333L6.15781 11.6667M8.73672 14.3333L6.15781 17"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconCompare
